import { render, staticRenderFns } from "./RequestURL.vue?vue&type=template&id=0b72cbf8&scoped=true&"
import script from "./RequestURL.vue?vue&type=script&lang=js&"
export * from "./RequestURL.vue?vue&type=script&lang=js&"
import style0 from "./RequestURL.vue?vue&type=style&index=0&id=0b72cbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72cbf8",
  null
  
)

export default component.exports